import type { EditorShape } from './types'

export function deepMergeShape(
  existing: EditorShape,
  partial: Partial<EditorShape>,
): EditorShape {
  const result = { ...existing }
  for (const key of Object.keys(partial) as (keyof EditorShape)[]) {
    const val = partial[key]
    if (val === undefined) continue
    if (key === 'props' || key === 'meta') {
      ;(result as unknown as Record<string, unknown>)[key] = {
        ...((existing as unknown as Record<string, unknown>)[key] as object),
        ...(val as object),
      }
    } else {
      ;(result as unknown as Record<string, unknown>)[key] = val
    }
  }
  return result as EditorShape
}
